// extracted by mini-css-extract-plugin
export default {"children":"ChildrenUndefined_children__FmvWy","children__text":"ChildrenUndefined_children__text__p3EAK","children--readOnly":"ChildrenUndefined_children--readOnly__Kj+KI"};